import * as React from 'react';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import FormEditingHandler from 'Containers/FormEditingHandler';
import Form from './Form';
import History from './HistoryRowData';

const Examination = ({ documents }: IOwnProps): React.JSX.Element => {
  return (
    <FormEditingHandler name="examination" documents={documents}>
      {(editing, startEdit, formData, view): React.JSX.Element => (
        <DocumentWrapper>
          <DocumentHeader
            name={'examination'}
            headerId={'examination.title'}
            editing={editing || view?.viewing}
            editButtons={
              <div>
                <DocumentCreationButton name="examination" text={'general.new'} onClick={startEdit({})} />
              </div>
            }
          />
          {editing || view?.viewing ? <Form formData={formData} view={view} /> : null}
          {!editing && !view?.viewing ? <History documents={documents} startEdit={startEdit} /> : <span />}
        </DocumentWrapper>
      )}
    </FormEditingHandler>
  );
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'examination'>[];
}

export default Examination;
